import styled from 'styled-components'
import { Card } from 'antd'
import { font, greys, borderRadius } from 'assets/themes/theme-default'

const AntCardStyled = styled(Card)`
  &&& {
    border-radius: ${borderRadius.base};
    background: ${greys.light3};
    margin-bottom: 15px;
    &.ant-card-bordered {
      border: 1px solid ${greys.dark3};
    }
    .ant-card-cover {
      border-radius: ${borderRadius.base} ${borderRadius.base} 0 0;
      overflow: hidden;
    }
    .ant-card-head {
      .ant-card-head-title {
        text-align: center;
        padding-bottom: 10px;
        border-bottom: 1px solid ${greys.dark3};
        color: ${greys.dark1};
      }
      .ant-card-extra {
       /* border-bottom: 1px solid ${greys.dark3};
        padding-bottom: 9px;*/
      }
    }
    .ant-card-meta {
      .ant-card-meta-title {
        text-align: center;
        padding-bottom: 10px;
        margin-bottom: 10px;
        border-bottom: 1px solid ${greys.dark3};
        color: ${greys.dark1};
        text-overflow: initial;
      }
    }
    .ant-card-actions {
      background: ${greys.dark3};
      color: ${greys.light4};
      border: 0 none;
      border-radius: 0 0 ${borderRadius.base} ${borderRadius.base};
    }
    .ant-card-body {
      color: ${greys.dark3};
      font-size: ${font.size.sm};
    }
  }
`
export default AntCardStyled
